import { Box, Button } from '@ff-it/ui';
import { RichTextField } from 'components/RichText';
import { ReactElement } from 'react';
import { Form } from 'react-final-form';
import type { MarkdownWrite } from 'components/RichText';

type CommentFormProps = {
  onCreate: (comment: MarkdownWrite) => Promise<void>;
};

type CommentValues = { comment?: MarkdownWrite };

export function CommentForm({ onCreate }: CommentFormProps): ReactElement {
  return (
    <Form<CommentValues>
      onSubmit={({ comment }, form) => {
        if (!comment) return;
        return onCreate(comment).then(
          () => form.restart(),
          () => ({ comment: 'Could not save your comment. Please try again.' }),
        );
      }}
    >
      {({ handleSubmit, submitting, values, form }) => (
        <Box as="form" p="4" borderTop="default" onSubmit={handleSubmit}>
          <RichTextField
            name="comment"
            placeholder="Write a comment..."
            readOnly={submitting}
            onSubmit={() => form.submit()}
            toolbar={({ pending }) => (
              <Button
                icon="paper-plane-top"
                type="submit"
                size="xxs"
                disabled={submitting || pending || !values.comment}
                spin={submitting}
                ml="auto"
              />
            )}
          />
        </Box>
      )}
    </Form>
  );
}
